import React from 'react';
import {IonButton, IonIcon, useIonAlert} from '@ionic/react';
import {calendarOutline, download, locationOutline, shareSocialOutline} from "ionicons/icons";
import moment from "moment-timezone";
import {callFunctionToDownload} from "../lib/downloadHelper";
import {Capacitor} from "@capacitor/core";
import {Share} from "@capacitor/share";

export default function EventsCard({ event, setEventDetailData,setIsEventDetailOpen,openTransactionListModal,openRegisterToEventModal}) {
    const [presentAlert] = useIonAlert();
    // const {currentMemberMemberShipDetail,userAuthDetail} = useStore();
    // const {memberShipDetail} = currentMemberMemberShipDetail;


    // useEffect(() => {
    //     if (!event?.price) return;
    //
    //     const original = event.price;
    //     let discountedPrice = original;
    //     let discount_percentage = 0;
    //
    //     if (memberShipDetail?.id) {
    //         discount_percentage = 60;
    //         discountedPrice = original * (1 - discount_percentage / 100); // 40% of original
    //     } else if (userInfo?.designation === 'ca_member') {
    //         discount_percentage = 40;
    //         discountedPrice = original * (1 - discount_percentage / 100); // 60% of original
    //     }
    //
    //     setPriceRef({ price: Math.round(discountedPrice), original, discount_percentage });
    // }, [event,memberShipDetail,userInfo]);


    const handleShareUrl = async (data) => {
        try {
            const url = `https://caworld.org/api-ca-world/common/shareAppContentData/event/${data?.id}`;
            const title = 'CA World Event';
            const text = 'Check out this event detail!';

            // Prefer native Share plugin when running in a Capacitor app.
            // Don't gate on canShare() for text/URL — it's mainly helpful for FILE sharing.
            const isNative = Capacitor.getPlatform() !== 'web';
            const hasPlugin = Capacitor.isPluginAvailable?.('Share');

            if (isNative && hasPlugin) {
                await Share.share({
                    title,
                    text,
                    url,                  // supports http/https and file://
                    dialogTitle: 'Share this event', // Android only
                });
                return;
            }

            // Web Share API (must be triggered from a direct user gesture)
            if (navigator?.share) {
                await navigator.share({ title, text, url });
                return;
            }

            // Fallbacks
            try {
                await navigator?.clipboard?.writeText?.(url);
                presentAlert({
                    header: 'Error Sharing!',
                    message: 'Link copied to clipboard!',
                    buttons: [{
                        text: 'Ok',
                    }],
                });
            } catch {
                window.prompt('Sharing is not supported. Copy this link:', url);
            }
        } catch (err) {
            console.error('Sharing failed:', err);
            presentAlert({
                header: 'Error Sharing!',
                message: 'Failed to share!',
                buttons: [{
                    text: 'Ok',
                }],
            });
        }
    };

    return (
        <div className="event-card" key={event.id}>
            <div className="event-card-img" onClick={() => {
                setIsEventDetailOpen(true)
                setEventDetailData(event)
            }}>
              <img src={event.image_url} alt={event.title} className="event-image"/>
            </div>
            <div className="event-details">
                <div onClick={() => {
                    setIsEventDetailOpen(true)
                    setEventDetailData(event)
                }}>
                    <h2 className="event-title">{event.title}</h2>
                    <div className="event-date-time"><IonIcon icon={calendarOutline}/>
                        <div>
                            {moment(event?.event_date_time).format("dddd, Do MMMM, YYYY")} ({moment(event?.event_date_time).format("h:mm A")} to {moment(event?.event_end_date_time).format("h:mm A")})
                        </div>
                    </div>
                    <div className="event-location"><IonIcon icon={locationOutline}/> <div>{event.location}</div></div>
                </div>
                <div className="event-footer">
                   <div className="event-price">
                       <span className="discounted-price">
                           {moment(event.event_date_time).isAfter(moment()) ? 'Upcoming Event' : 'Event Passed'}
                       </span>
                    </div>
                    <div className={"event-action-section"}>
                        <IonButton onClick={() => {
                            setIsEventDetailOpen(true)
                            setEventDetailData(event)
                        }} size="small" className="detail-now-button">
                            Detail
                        </IonButton>
                        <IonButton onClick={() => callFunctionToDownload(event.pdf_url)} size="small" className="detail-now-button">
                            <IonIcon icon={download}></IonIcon>
                        </IonButton>
                        <IonButton onClick={() => handleShareUrl(event)} size="small" className="detail-now-button">
                            <IonIcon icon={shareSocialOutline}></IonIcon>
                        </IonButton>
                        {(event?.member_registrations?.length) ?
                            <IonButton size="small" onClick={()=>openTransactionListModal(event?.member_registrations)} className="buy-now-button">
                                View
                            </IonButton>
                            :
                            <>
                            {(moment(event.event_date_time) > moment()) && (
                                <IonButton onClick={()=>openRegisterToEventModal(event)} size="small" className="buy-now-button">
                                    Register Now
                                </IonButton>
                            )}
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

